import Dialog from './Dialog'

export default Dialog

export { default as IsModelessProvider } from './IsModelessProvider'
